export function currencyFormat(value: number | string, withSymbol = true) {
  const nValue = typeof value === 'number' ? value : parseFloat(`${value || 0}`);

  const v = nValue.toLocaleString('en-US', { style: 'currency', currency: 'USD' });

  return withSymbol ? v : v.replace('$', '');
}
